import { render, staticRenderFns } from "./RichVerticalIndicator.vue?vue&type=template&id=2fbd0da8&scoped=true"
import script from "./RichVerticalIndicator.vue?vue&type=script&lang=js"
export * from "./RichVerticalIndicator.vue?vue&type=script&lang=js"
import style0 from "./RichVerticalIndicator.vue?vue&type=style&index=0&id=2fbd0da8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd0da8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbd0da8')) {
      api.createRecord('2fbd0da8', component.options)
    } else {
      api.reload('2fbd0da8', component.options)
    }
    module.hot.accept("./RichVerticalIndicator.vue?vue&type=template&id=2fbd0da8&scoped=true", function () {
      api.rerender('2fbd0da8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-wizard/indicators/RichVerticalIndicator.vue"
export default component.exports